/**
 * UI copy shared across the order tabs (Details, Shipments). Lives at the tab-group level so no
 * tab depends on another tab's module for shared strings.
 */

/** Approved copy; must match the design exactly. Shared by the Details and Shipments tabs. */
export const EXPECTED_SHIP_DATE_TOOLTIP = "Expected Ship Date is calculated based on when the order was paid.";
